import { helperGetIsoDate } from "../utils/helpers";

const linda1 = {
  newSymptomsLast3Months: 0,
  treatmentPlans: [
    {
      priorAuthorization: "NA",
      dxDate: "2004-04-12",
      currentTherapy: [
        {
          name: "GILENYA",
          type: "pill",
          description: "",
          firstFilledDate: "2018-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-03-28",
        },
        {
          name: "ibuprofen",
          type: "pill",
          description: "",
          firstFilledDate: "2020-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-03-28",
        },
        {
          name: "Duloxetine",
          type: "pill",
          description: "",
          firstFilledDate: "2021-01-21",
          newestEnrollmentDate: "2021-03-05",
          refillDate: "2021-06-28",
        },
        {
          name: "Zolpidem",
          type: "pill",
          description: "",
          firstFilledDate: "2021-01-21",
          newestEnrollmentDate: "2021-03-05",
          refillDate: "2021-06-28",
        },
      ],
      previousTherapy: [
        {
          name: "AUBAGIO",
          type: "pill",
          description: "",
          firstFilledDate: "2018-04-12",
          newestEnrollmentDate: "2018-04-12",
        },
        {
          name: "REBIF",
          type: "injection",
          description: "",
          firstFilledDate: "2017-04-12",
          newestEnrollmentDate: "2017-04-12",
        },
        {
          name: "AVONEX",
          type: "injection",
          description: "",
          firstFilledDate: "2004-04-12",
          newestEnrollmentDate: "2016-04-12",
        },
      ],
      compliance: [
        {
          date: "2021-02-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-29",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-03-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-04-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-05-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-06-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-06",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-07-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-15",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-07-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-14",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-11",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-10-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-21",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-11-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-12",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-15",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-19",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-23",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-30",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-03",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-01-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-18",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-01-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-10",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-22",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-24",
          compliance: 1,
          note: "",
        },
      ],
    },
  ],
  relapsesLast3Months: 1,
  relapsesLast12Months: 1,
  assessments: {
    physicalMSQOL: [
      {
        date: "2020-05-25",
        value: 69,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 59,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 59,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 56,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 52,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 50,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 49,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 48,
        note: "",
      },
    ],
    mentalMSQOL: [
      {
        date: "2020-05-25",
        value: 55,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 54,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 55,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 53,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 49,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 49,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 47,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 45,
        note: "",
      },
    ],
    timedWalk: [
      {
        date: "2021-02-25",
        value: 8,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 8.3,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 8.1,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 8.5,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 8.1,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 9.9,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 8.8,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 9,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 9.5,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 9.5,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 9.7,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 10.8,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 10.5,
        note: "",
      },
    ],
    phq8: [
      {
        date: "2021-02-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 9,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 5,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 8,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 8,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 12,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 6,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 11,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 8,
        note: "",
      },
    ],
  },
  symptoms: {
    difficultyWalking: {
      data: [
        {
          date: "2021-08-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
    },
    memoryCognition: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 6,
          note: "",
        },
      ],
      active: true,
    },
    fatigue: {
      data: [
        {
          date: "2021-02-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
    },
    depression: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 6,
          note: "",
        },
      ],
      active: true,
    },
    pain: {
      data: [
        {
          date: "2021-02-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 7,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 8,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 6,
          note: "",
        },
      ],
      active: true,
    },
  },
  goals: {
    steps: {
      data: [
        {
          date: "2021-02-26",
          value: 4479,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4070,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 5371,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2010,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 3832,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 2734,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 3616,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 2547,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 2370,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5916,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3582,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1736,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 2973,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 2512,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1856,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 200,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 2349,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 2261,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 1421,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 228,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 3817,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 4105,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 200,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 200,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2055,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2243,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 3960,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 2368,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1317,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 5368,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 804,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 3139,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3111,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 965,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3076,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3997,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 2297,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 4744,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 3773,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2772,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3122,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5611,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3558,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1368,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 1383,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1757,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1591,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1767,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1539,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 4640,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 385,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2733,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2113,
          note: "",
        },
      ],
      active: true,
      target: 3500,
    },
    walkingSpeed: {
      data: [
        {
          date: "2021-02-26",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 0.5,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 0.7,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 0.7,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 0.7,
          note: "",
        },
      ],
      active: true,
      target: 0.9,
    },
    deviceTime: {
      data: [
        {
          date: "2021-02-26",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 11.5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 10.9,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 12.6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 0.3,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 14.5,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5.1,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 4.7,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 3.7,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5.5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 6.1,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 5.1,
          note: "",
        },
      ],
      active: true,
      target: 6,
    },
    sleepHours: {
      data: [
        {
          date: "2021-02-26",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 9,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 8,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 8,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 9,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 11,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 9,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 8.2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 9,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 9.9,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 8.2,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6.7,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 8.9,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 8.3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 8.3,
          note: "",
        },
      ],
      active: true,
      target: 7.5,
    },
    nightWakings: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 8,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 4,
          note: "",
        },
      ],
      active: true,
      target: 2,
    },
    feelingScore: {
      data: [
        {
          date: "2021-02-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
      target: 5,
    },
  },
  conditions: {
    "multiple sclerosis": {
      diagnosed: "2004-04-12",
      note: "",
    },
    depression: {
      diagnosed: "2019-04-12",
      note: "",
    },
  },
  medications: {
    GILENYA: {
      form: "pill",
      refillDate: "2021-03-28",
      dosage: "0.5 mg",
      schedule: {
        times: 1,
        timeUnit: "day",
      },
      note: "Gilenya 0.5 mg tablet,  one tablet by mouth once daily",
      priorAuthorization: "not required",
    },
    ibuprofen: {
      form: "pill",
      refillDate: "2021-03-28",
      dosage: "400 mg",
      schedule: {
        times: 3,
        timeUnit: "day",
      },
      note: "Ibuprofen 200 mg tablet, two tablets by mouth every 8 hours as needed for pain",
    },
    Duloxetine: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "20 mg",
      schedule: {
        times: 2,
        timeUnit: "day",
      },
      note: "Duloxetine 20 mg tablet, one tablet by mouth twice daily (depression and neuro pain)",
    },
    Zolpidem: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "5 mg",
      schedule: {
        times: 1,
        timeUnit: "day",
      },
      note: "Zolpidem 5 mg tablet, one tablet by mouth before bedtime as needed for sleep",
    },
  },
};

const linda2 = {
  newSymptomsLast3Months: 0,
  treatmentPlans: [
    {
      priorAuthorization: "NA",
      dxDate: "2018-06-17",
      currentTherapy: [
        {
          name: "GILENYA",
          type: "pill",
          description: "",
          firstFilledDate: "2019-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-06-28",
        },
      ],
      previousTherapy: [
        {
          name: "AUBAGIO",
          type: "pill",
          description: "",
          firstFilledDate: "2018-04-12",
          newestEnrollmentDate: "2018-04-12",
        },
        {
          name: "REBIF",
          type: "injection",
          description: "",
          firstFilledDate: "2017-04-12",
          newestEnrollmentDate: "2017-04-12",
        },
        {
          name: "AVONEX",
          type: "injection",
          description: "",
          firstFilledDate: "2004-04-12",
          newestEnrollmentDate: "2016-04-12",
        },
      ],
      compliance: [
        {
          date: "2021-02-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-26",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-02-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-03-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-05",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-04-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-16",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-06-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-17",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-07-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-08-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-15",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-08-16",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-08-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-04",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-16",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-10",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-10-11",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-10-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-07",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-25",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-03",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-01-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-03",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-24",
          compliance: 0,
          note: "",
        },
      ],
    },
  ],
  relapsesLast3Months: 1,
  relapsesLast12Months: 1,
  assessments: {
    physicalMSQOL: [
      {
        date: "2020-05-25",
        value: 87,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 89,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 82,
        note: "",
      },
      {
        date: "2021-01-26",
        value: 86,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 87,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 87,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 78,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 86,
        note: "",
      },
    ],
    mentalMSQOL: [
      {
        date: "2020-05-25",
        value: 86,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 81,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 74,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 84,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 85,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 85,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 78,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 82,
        note: "",
      },
    ],
    timedWalk: [
      {
        date: "2021-02-25",
        value: 5.4,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 5.4,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 4.7,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 5.3,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 5.5,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 5.3,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 5.6,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 5.2,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 5.4,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 6.5,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 5.4,
        note: "",
      },
    ],
    phq8: [
      {
        date: "2021-02-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 5,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 2,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 9,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 5,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 6,
        note: "",
      },
    ],
  },
  symptoms: {
    speechSwallowing: {
      data: [
        {
          date: "2021-02-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 1,
          note: "",
        },
      ],
      active: true,
    },
    fatigue: {
      data: [
        {
          date: "2021-02-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 1,
          note: "",
        },
      ],
      active: true,
    },
    depression: {
      data: [
        {
          date: "2021-02-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 1,
          note: "",
        },
      ],
      active: true,
    },
  },
  goals: {
    steps: {
      data: [
        {
          date: "2021-02-25",
          value: 9603,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 10984,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 12580,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 8814,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 9018,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 10243,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 9580,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 10179,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 13260,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 7655,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 5165,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 6840,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 4224,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 9468,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 9504,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 10298,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 15554,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 11671,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 13598,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 10600,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 6189,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 13054,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 4386,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 4913,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 5441,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 13301,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 6809,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 11702,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 9260,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 10666,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 6580,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 8878,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 13318,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 8793,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 12522,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 14570,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4350,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 12357,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 12718,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 3787,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 13707,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 8169,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 10984,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 12532,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 15023,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 11359,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 10593,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 6552,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 15169,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 14421,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 18276,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 9867,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 8087,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 738,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 5529,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 11238,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 13010,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 9976,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 8038,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 7725,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 5269,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 8299,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 4942,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 5648,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 10716,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 13613,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 4516,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 15451,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 9622,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 11262,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 6495,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 9139,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 9632,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 11602,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 2971,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 14493,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 6098,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 8890,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 4213,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 13221,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 7523,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 11144,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 4313,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 11474,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 14244,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 13560,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 7541,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 9832,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 4762,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 9842,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 3504,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 10899,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 10129,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 8183,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 8650,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 15808,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 19468,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 2601,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 11588,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 3581,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 9655,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 17569,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 12915,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 2256,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 10749,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 18577,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 5472,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 10289,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 11628,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 13694,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 11385,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 14019,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 6065,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 9509,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 7881,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 7654,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 6591,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 9443,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 10473,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 9803,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 2673,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 8720,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 5045,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 10600,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 7792,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 11243,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 6626,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 12665,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 14124,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 738,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 11979,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 12641,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 5839,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 5647,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 738,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 14537,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 8840,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 13078,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 5820,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 4805,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 8248,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 15547,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 16065,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 5359,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 11028,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 7515,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 14440,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 738,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 7805,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 7476,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 8178,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 5824,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 11260,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 5191,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 9074,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 15812,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 10153,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 2648,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 13243,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 11721,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 6533,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 15546,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 12257,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 12097,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 11583,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 9845,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 8724,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 5086,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 12951,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 15080,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 11012,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 7370,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 15741,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 6365,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 9017,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 4673,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 4201,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 13043,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 10489,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 12322,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 9801,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 10210,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 3063,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 6074,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 10298,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 10842,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 8771,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 10170,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 5274,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 7393,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4472,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 12682,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 11912,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 13946,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 7295,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 15684,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 16805,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 8027,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 6745,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 10073,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 3386,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 3963,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 7883,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 15065,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 18675,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 8297,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 10836,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 3077,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 13031,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 13749,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 11953,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 13761,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 13350,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 10742,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 5832,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 10897,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 12763,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 13871,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 17419,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 7573,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 10443,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 8648,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 6883,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 4058,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 3007,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 5314,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 6567,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 9884,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 6804,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 10148,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 3546,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 8841,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 9327,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 10979,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 3695,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 12309,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 14691,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 5765,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 6673,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 738,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 12006,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 15851,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 12949,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 11976,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 3545,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 6402,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 10412,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 10807,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 9121,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 8478,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 3591,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 11424,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 14114,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 2845,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 9960,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 10189,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 7857,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 8078,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 5655,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 10673,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 13503,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 7681,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 10358,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 16022,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 4971,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 5501,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 11136,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 10076,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 5627,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 6903,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 2800,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 13399,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 4734,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 8126,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 18912,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 5887,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 6599,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 11266,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 15736,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 8959,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 11175,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 10810,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 6465,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 7616,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 8428,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 7399,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 3008,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 11660,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5092,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 10256,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 821,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 7815,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 18362,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 7904,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 11264,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 6191,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 3855,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 10132,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 15408,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 6065,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 3846,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 10936,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 11838,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 8340,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 11337,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 10190,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 12038,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 10686,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 9273,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 13724,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 6850,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 13679,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 17629,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 5110,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 8118,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 5780,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 5194,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 8348,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 7592,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 5939,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 3706,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 3124,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 10698,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 8711,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 10330,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 3882,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 7765,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 5175,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 6023,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 13630,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1438,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 7188,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 2804,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 9435,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 13826,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 8496,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 10984,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 9519,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 738,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 2432,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 13638,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 12630,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 12244,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 8788,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 9178,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 4664,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 11923,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 9419,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 9867,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 16096,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 738,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 13691,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 15047,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 6314,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 11263,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 5508,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 6632,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 8491,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 6512,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 5940,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 8640,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 10745,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 1968,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 21498,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 13633,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 9603,
          note: "",
        },
      ],
      active: true,
      target: 10000,
    },
    walkingSpeed: {
      data: [
        {
          date: "2021-02-25",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-02-28",
          value: -1.2,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 5.2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 8,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 4.4,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-05-16",
          value: -0.5,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 0.4,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 5.2,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-06-19",
          value: -1.1,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 0.3,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-06-26",
          value: -2,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 0.5,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 0.2,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 4.6,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 5.2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 10.4,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 4.6,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 0.2,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-16",
          value: -0.3,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-09-19",
          value: -0.7,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 0.3,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-09-24",
          value: -0.3,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 4.6,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-11-01",
          value: -0.7,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-12-01",
          value: -1.3,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 5.2,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-12-20",
          value: -1.1,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-12-28",
          value: -0.3,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 3.1,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 5.7,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 4.4,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 5.7,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 3.1,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 5.1,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1.7,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 0.5,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 5.2,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 2.8,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 2.2,
          note: "",
        },
        {
          date: "2022-01-13",
          value: -0.4,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 3.6,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 2.2,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 3.7,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 0.1,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 4.7,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 5.6,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 0.3,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 4.4,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 9.4,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 4.4,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 4.1,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 2.5,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 1.7,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 4.2,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 6.3,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 3.7,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 4.7,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 4.9,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 5.7,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 6.1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 2.2,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 5.5,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 5.4,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 5.9,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 6.5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 4.8,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 6.5,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 3.1,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 6.2,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 1.6,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 5.7,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3.7,
          note: "",
        },
      ],
      active: true,
      target: 3.75,
    },
    deviceTime: {
      data: [
        {
          date: "2021-02-25",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 0.4,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4.4,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 0.5,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 0.4,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 0.3,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 4.4,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 4.4,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 7,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 4.7,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 4.4,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 4.6,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 4.1,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 4.6,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 0.4,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 0.2,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 0.4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 5.6,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 0.5,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 0.2,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 5.2,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 0.5,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 0.1,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 4.3,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 3.8,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 5.5,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 6.5,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 1.7,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 3.8,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 7.8,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 3.3,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 1.7,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 2.5,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 6.3,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 3.3,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 1.8,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 3.3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 3.5,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 3.5,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 2.8,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 5.3,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 1.6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 0.3,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 4.2,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 0.3,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 3.9,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 3.1,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 3.6,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 4.2,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 4.9,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 7.3,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 0.1,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 4.3,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 0.3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2.5,
          note: "",
        },
      ],
      active: true,
      target: 2.5,
    },
    sleepHours: {
      data: [
        {
          date: "2021-02-25",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 8,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 9.9,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 8,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 8,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 8,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 7,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 9,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 10.2,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 9,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 8,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 9.8,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 10.2,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 8,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 9,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 8,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 9,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 9,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 10.7,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 8,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 10.8,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 9,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 10.7,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 7,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 9,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 8,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 9,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 10.5,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 10.2,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 10.2,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 10.9,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 11.1,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 9.9,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 11.6,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 10.4,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 8,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 9.8,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 11.1,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 11.4,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 9,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 10.5,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 10.5,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 9.8,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 9,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 10.7,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 10,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 9,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 10,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 10.9,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 9,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 9,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 9.7,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 9.8,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 9.1,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 9.7,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 8.2,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 10,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 8.7,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 7.9,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 9,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 8.9,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 8.8,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 8.4,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 8.6,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 7.8,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 7.4,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 11.4,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 7.2,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 8.9,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 8.8,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 6.8,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 7.9,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 5.3,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 8.3,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 9,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 8.1,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 10.1,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 9.9,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 8.5,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 9.4,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 8.5,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 9.4,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 8.4,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6.8,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 6.5,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 8.9,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 6.5,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 5.9,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 9,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 9.4,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 7.8,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 5.8,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 8.7,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 8.4,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 5.9,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 6.7,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 9.1,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 8.4,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 9.7,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 7.9,
          note: "",
        },
      ],
      active: true,
      target: 8,
    },
    nightWakings: {
      data: [
        {
          date: "2021-02-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 0,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 0,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 0,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 0,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 0,
          note: "",
        },
      ],
      active: true,
      target: 0,
    },
    feelingScore: {
      data: [
        {
          date: "2021-02-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 4,
          note: "",
        },
      ],
      active: true,
      target: 5,
    },
  },
  conditions: {
    "multiple sclerosis": {
      diagnosed: "2018-06-17",
      note: "",
    },
  },
  medications: {
    GILENYA: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "0.5 mg",
      schedule: {
        times: 1,
        timeUnit: "day",
      },
      note: "Gilenya 0.5 mg tablet,  one tablet by mouth once daily",
    },
  },
};

const linda3 = {
  newSymptomsLast3Months: 1,
  treatmentPlans: [
    {
      priorAuthorization: "NA",
      dxDate: "",
      currentTherapy: [
        {
          name: "GILENYA",
          type: "pill",
          description: "",
          firstFilledDate: "2018-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-03-28",
        },
        {
          name: "BACLOFEN",
          type: "pill",
          description: "",
          firstFilledDate: "2019-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-06-28",
        },
        {
          name: "NEURONTIN",
          type: "pill",
          description: "",
          firstFilledDate: "2019-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-06-28",
        },
        {
          name: "ZOLOFT",
          type: "pill",
          description: "",
          firstFilledDate: "2019-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-06-28",
        },
        {
          name: "LISINOPRIL",
          type: "pill",
          description: "",
          firstFilledDate: "2016-10-31",
          newestEnrollmentDate: "2021-01-05",
          refillDate: "2021-06-28",
        },
      ],
      previousTherapy: [
        {
          name: "AUBAGIO",
          type: "pill",
          description: "",
          firstFilledDate: "2018-04-12",
          newestEnrollmentDate: "2018-04-12",
        },
        {
          name: "REBIF",
          type: "injection",
          description: "",
          firstFilledDate: "2017-04-12",
          newestEnrollmentDate: "2017-04-12",
        },
        {
          name: "AVONEX",
          type: "injection",
          description: "",
          firstFilledDate: "2004-04-12",
          newestEnrollmentDate: "2016-04-12",
        },
      ],
      compliance: [
        {
          date: "2021-02-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-28",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-03-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-07",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-03-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-15",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-03-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-01",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-04-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-08",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-04-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-13",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-04-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-15",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-04-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-17",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-04-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-22",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-04-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-24",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-04-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-05-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-03",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-05-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-06",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-05-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-08",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-05-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-11",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-05-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-25",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-05-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-05-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-30",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-05-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-01",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-06-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-06",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-06-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-08",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-06-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-06-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-06-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-24",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-06-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-28",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-06-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-07",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-07-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-10",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-07-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-17",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-07-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-24",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-07-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-29",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-07-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-07",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-08-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-08-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-19",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-08-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-28",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-08-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-30",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-08-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-06",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-09-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-14",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-09-15",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-19",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-09-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-29",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-02",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-10-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-05",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-10-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-07",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-10-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-10-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-20",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-10-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-27",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-10-28",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-10-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-30",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-10-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-02",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-11-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-08",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-11-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-11-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-15",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-11-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-17",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-11-18",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-11-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-23",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-11-24",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-11-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-01",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-12-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-12-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-05",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-12-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-09",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-12-10",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-12-11",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-12-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-19",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-12-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-23",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2021-12-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-29",
          compliance: 0.8,
          note: "",
        },
        {
          date: "2021-12-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-01",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-01-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-07",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2022-02-08",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-09",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2022-02-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-12",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2022-02-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-15",
          compliance: 0.6,
          note: "",
        },
        {
          date: "2022-02-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-21",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-24",
          compliance: 1,
          note: "",
        },
      ],
    },
  ],
  relapsesLast3Months: 1,
  relapsesLast12Months: 2,
  assessments: {
    physicalMSQOL: [
      {
        date: "2020-05-25",
        value: 50,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 46,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 44,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 47,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 54,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 54,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 42,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 44,
        note: "",
      },
    ],
    mentalMSQOL: [
      {
        date: "2020-05-25",
        value: 41,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 38,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 39,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 40,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 41,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 41,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 32,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 36,
        note: "",
      },
    ],
    timedWalk: [
      {
        date: "2021-02-25",
        value: 7.7,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 6.6,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 6.9,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 6.7,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 6.3,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 6.1,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 6.7,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 6.8,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 8.1,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 8.6,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 8.6,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 8.7,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 8.2,
        note: "",
      },
    ],
    phq8: [
      {
        date: "2021-02-25",
        value: 15,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 16,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 13,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 14,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 16,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 23,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 14,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 17,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 20,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 18,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 10,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 24,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 16,
        note: "",
      },
    ],
  },
  symptoms: {
    difficultyWalking: {
      data: [
        {
          date: "2021-11-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2,
          note: "",
        },
      ],
      active: true,
    },
    memoryCognition: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 5,
          note: "",
        },
      ],
      active: true,
    },
    fatigue: {
      data: [
        {
          date: "2021-02-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 7,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 8,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 8,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 8,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 8,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 8,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 8,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 8,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 8,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 8,
          note: "",
        },
      ],
      active: true,
    },
    depression: {
      data: [
        {
          date: "2021-08-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2,
          note: "",
        },
      ],
      active: true,
    },
    pain: {
      data: [
        {
          date: "2021-02-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 9,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 7,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 8,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 8,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 7,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 8,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 9,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 9,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 9,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 8,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 8,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 6,
          note: "",
        },
      ],
      active: true,
    },
  },
  goals: {
    steps: {
      data: [
        {
          date: "2021-02-25",
          value: 4628,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 2905,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 4424,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 3048,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 7312,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 4407,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 2914,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 6872,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 5115,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 7413,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 3348,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 2352,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 5753,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 3414,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 4813,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 7019,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 6470,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 5277,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 5351,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 4435,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 4405,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 4019,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 3520,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 4592,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 3122,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 3717,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 4873,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 3977,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 2161,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 2700,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 3281,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 3332,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 4194,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 2716,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 5213,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 5528,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4256,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 7530,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 4154,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 4612,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 5162,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 5050,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 5457,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 4983,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 6046,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 3384,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 7777,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 3475,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 5269,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 6860,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 4097,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 3687,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 5817,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 3999,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 5580,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 5111,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 4603,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 5063,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 5945,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 4899,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 6218,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 7546,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 4183,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 5747,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5618,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 6465,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 5016,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 2124,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 5511,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 7825,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 7450,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 7275,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 5952,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 6190,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 6039,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 3210,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 4494,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 5568,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 3601,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 4850,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 4409,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 5913,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 5339,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 4260,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 4310,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6302,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 3247,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 4536,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 4720,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 5318,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 5312,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 7520,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5901,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 4817,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 5126,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 3186,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 3684,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 5492,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 5693,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 3459,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 4773,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 8242,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 3851,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 4065,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 7701,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 4579,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 7350,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 4449,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 5453,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 5319,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 6639,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 7771,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 6702,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 3833,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 5062,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 2278,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 5207,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 4609,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 4473,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 6164,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 6648,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 5999,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 5153,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 4787,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 5734,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 4763,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 4760,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 5054,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 4385,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 6590,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 5427,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 6660,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 5753,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 6260,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 6987,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 6799,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 8003,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 6058,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 5874,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 4428,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 6028,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 4461,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 3046,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 5409,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 7316,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 7430,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 4560,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 6323,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 6158,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 7583,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 5512,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 5679,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 6458,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 6395,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 5860,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 6709,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 5153,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 3064,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 6103,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 7552,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 5095,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 6100,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 9355,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 5857,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 3339,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 5426,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 6887,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 4623,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 5266,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 3871,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 4773,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 6962,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 7076,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 7366,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 7399,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 6201,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 6952,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 8991,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 5386,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 3104,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 4234,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 5318,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 3099,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 2807,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 5451,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 4692,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 8386,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 6977,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 4364,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 6483,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 3780,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 6617,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 7236,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 3831,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 3477,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 3347,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 6565,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 2932,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 4681,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 4288,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 6189,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 5745,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 4843,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 4604,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3142,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 4408,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 3851,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 3249,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 5613,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 5779,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 4174,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 7181,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 4870,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 2988,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 6183,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 4844,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 1789,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 4870,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 3903,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 5156,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 3613,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 5839,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 6794,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 2779,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 4593,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3952,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 5193,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 4960,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 5919,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 6206,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 2964,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 4717,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 4762,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 4939,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 4640,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 3740,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 3449,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 2286,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 5965,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 5777,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 2897,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 3998,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 4416,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 4567,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 3881,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 2370,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3887,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 4912,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 2347,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 7014,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 3527,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 5342,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 2750,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 4048,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 5174,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 3099,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 3707,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 3649,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 5364,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 6994,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 3016,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 3577,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 4132,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 3999,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 3897,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 4274,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 2799,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5376,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 4150,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 5513,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 3136,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 4688,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 1941,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 4136,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 4776,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 3494,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 5096,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 7445,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 3861,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 3336,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 5473,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 2214,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 4308,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 3011,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 4289,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 3441,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 4213,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 738,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5820,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 5415,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 4828,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 3004,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 2673,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 4420,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 3746,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5933,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 6168,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 4846,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 6137,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 993,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 3276,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 6082,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 4442,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 3092,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 1344,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 1901,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 1903,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 4869,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 5903,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5071,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 2544,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 6828,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 4168,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 4515,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 5164,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 7055,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2496,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 868,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 5276,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 6066,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 7572,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 3626,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 2132,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 738,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 4790,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 3982,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 6496,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 3914,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 2732,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 6110,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1563,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 3696,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 5022,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 1491,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 5625,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 6560,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 6931,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 4954,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 3493,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 6281,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 3230,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 5596,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 4951,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 2509,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 2158,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 5103,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 2451,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 4872,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 3392,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 3272,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 4411,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5073,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 3861,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 3003,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 933,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 5093,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 5273,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 5115,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2320,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 2285,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 2113,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 7756,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 2442,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 3394,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 5351,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 4333,
          note: "",
        },
      ],
      active: true,
      target: 5000,
    },
    walkingSpeed: {
      data: [
        {
          date: "2021-02-25",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 1.3,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 1.6,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 0.7,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 0.7,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 1.6,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 1.1,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 1.1,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 1.1,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 1.1,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 1.1,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 1.3,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 1.5,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 1.2,
          note: "",
        },
      ],
      active: true,
      target: 2,
    },
    deviceTime: {
      data: [
        {
          date: "2021-02-25",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 3.8,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 3.9,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 3.2,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 3.7,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 3.5,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3.1,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 2.4,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 1.6,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 2.1,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 1.9,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 1.8,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 1.4,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 2.8,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 1.1,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 2.9,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 3.3,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 2.7,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 2.6,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 2.5,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 2.2,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 1.5,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 2.1,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 1.4,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 2.1,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 1.6,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 2.9,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 1.7,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 3.3,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 2.2,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 2.2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2.9,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 2.5,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 2.8,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1.9,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 3.1,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 2.1,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 1.7,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 2.9,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 1.2,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 2.2,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 2.8,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2.6,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 1.9,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 2.7,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 1.9,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 2.9,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 2.9,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 1.9,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2.5,
          note: "",
        },
      ],
      active: true,
      target: 3,
    },
    sleepHours: {
      data: [
        {
          date: "2021-02-25",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 4.4,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 8,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 8,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 10.4,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 8,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 10.8,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 8,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 8,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 5.2,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 8,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 4.8,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 8,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 8,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 8,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 8,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 6.3,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 9,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 8,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 6.2,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 5.9,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 7.7,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 7.2,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 8.1,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 5.2,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 7.4,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 8.6,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 6.8,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 8.4,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 7.2,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 5.5,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 5.7,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 6.2,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 7.9,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 7.2,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 6.1,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 8.7,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 8.7,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 6.8,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 8.5,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 7.4,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 8,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 8.6,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 8,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 7.7,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 8.3,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 7.3,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 8.9,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 6.4,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 6.6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 6.2,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 7.3,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 7.2,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 6.7,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 7.1,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 7.8,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 6.7,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 7.2,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 6.8,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 6.1,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 7.1,
          note: "",
        },
      ],
      active: true,
      target: 7.5,
    },
    nightWakings: {
      data: [
        {
          date: "2021-02-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 1,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 1,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2,
          note: "",
        },
      ],
      active: true,
      target: 1,
    },
    feelingScore: {
      data: [
        {
          date: "2021-02-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-02-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-02-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-02-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-18",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-31",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-18",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-29",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-14",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-29",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-11",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-17",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-29",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-15",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-31",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-06",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-07",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-18",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-18",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-31",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-02",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-04",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-18",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-01",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-02",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-03",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-04",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-05",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-06",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-08",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-09",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-10",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-11",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-12",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-13",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-15",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-16",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-17",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-19",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-20",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-22",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-23",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-24",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-25",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-26",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-27",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-29",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-30",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-31",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-01",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-02",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-03",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-05",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-06",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-07",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-08",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-09",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-10",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-12",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-13",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-14",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-15",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-16",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-17",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-19",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-20",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-21",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-22",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-23",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-24",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
      target: 5,
    },
  },
  conditions: {
    "multiple sclerosis": {
      diagnosed: "2011-08-11",
      note: "",
    },
    depression: {
      diagnosed: "2017-04-12",
      note: "",
    },
    Hypertension: {
      diagnosed: "2014-04-12",
      note: "",
    },
  },
  medications: {
    GILENYA: {
      form: "pill",
      refillDate: "2021-03-28",
      dosage: "0.5 mg",
      schedule: {
        times: 1,
        timeUnit: "day",
      },
      note: "Gilenya 0.5 mg tablet,  one tablet by mouth once daily",
    },
    BACLOFEN: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "10 mg",
      schedule: {
        times: 3,
        timeUnit: "day",
      },
      note: "Baclofen 10 mg tablet, one tablet by mouth three times daily (TID)",
    },
    NEURONTIN: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "600 mg",
      schedule: {
        times: 3,
        timeUnit: "day",
      },
      note: "Neurontin 300 mg capsule, two capsules by mouth three times daily (TID)",
    },
    ZOLOFT: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "50 mg",
      schedule: {
        times: 1,
        timeUnit: "day",
      },
      note: "Zoloft 50 mg tablet, one tablet by mouth once daily",
    },
    LISINOPRIL: {
      form: "pill",
      refillDate: "2021-06-28",
      dosage: "10 mg",
      schedule: {
        times: 1,
        timeUnit: "day",
      },
      note: "Lisinopril 10 mg tablet, one tablet by mouth once daily ",
    },
  },
};

const mae1 = {
  newSymptomsLast3Months: 0,
  treatmentPlans: [
    {
      priorAuthorization: "NA",
      dxDate: "2004-04-12",
      currentTherapy: [
        {
          name: "GILENYA",
          type: "pill",
          description: "",
        },
      ],
      previousTherapy: [
        {
          name: "AUBAGIO",
          type: "pill",
          description: "",
        },
        {
          name: "REBIF",
          type: "injection",
          description: "",
        },
        {
          name: "AVONEX",
          type: "injection",
          description: "",
        },
      ],
      compliance: [
        {
          date: "2021-02-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-02-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-29",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-03-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-03-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-23",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-04-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-04-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-14",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-05-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-05-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-11",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-06-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-06-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-06",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-07-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-15",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-07-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-07-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-08-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-14",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-09-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-09-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-11",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-10-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-10-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-21",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-11-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-11-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-12",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-15",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-19",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-23",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2021-12-30",
          compliance: 0,
          note: "",
        },
        {
          date: "2021-12-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-03",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-01-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-10",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-18",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-01-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-22",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-24",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-25",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-26",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-27",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-28",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-29",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-30",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-01-31",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-01",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-02",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-03",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-04",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-05",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-06",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-07",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-08",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-09",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-10",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-11",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-12",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-13",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-14",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-15",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-16",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-17",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-18",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-19",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-20",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-21",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-22",
          compliance: 0,
          note: "",
        },
        {
          date: "2022-02-23",
          compliance: 1,
          note: "",
        },
        {
          date: "2022-02-24",
          compliance: 1,
          note: "",
        },
      ],
    },
  ],
  relapsesLast3Months: 1,
  relapsesLast12Months: 1,
  assessments: {
    physicalMSQOL: [
      {
        date: "2020-05-25",
        value: 69,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 59,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 59,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 56,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 52,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 50,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 49,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 48,
        note: "",
      },
    ],
    mentalMSQOL: [
      {
        date: "2020-05-25",
        value: 55,
        note: "",
      },
      {
        date: "2020-08-25",
        value: 54,
        note: "",
      },
      {
        date: "2020-11-25",
        value: 55,
        note: "",
      },
      {
        date: "2021-02-25",
        value: 53,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 49,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 49,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 47,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 45,
        note: "",
      },
    ],
    timedWalk: [
      {
        date: "2021-02-25",
        value: 8,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 8.3,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 8.1,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 8.5,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 8.1,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 9.9,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 8.8,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 9,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 9.5,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 9.5,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 9.7,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 10.8,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 10.5,
        note: "",
      },
    ],
    phq8: [
      {
        date: "2021-02-25",
        value: 6,
        note: "",
      },
      {
        date: "2021-03-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-04-25",
        value: 9,
        note: "",
      },
      {
        date: "2021-05-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-06-25",
        value: 5,
        note: "",
      },
      {
        date: "2021-07-25",
        value: 8,
        note: "",
      },
      {
        date: "2021-08-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-09-25",
        value: 8,
        note: "",
      },
      {
        date: "2021-10-25",
        value: 12,
        note: "",
      },
      {
        date: "2021-11-25",
        value: 7,
        note: "",
      },
      {
        date: "2021-12-25",
        value: 6,
        note: "",
      },
      {
        date: "2022-01-25",
        value: 11,
        note: "",
      },
      {
        date: "2022-02-25",
        value: 8,
        note: "",
      },
    ],
  },
  symptoms: {
    difficultyWalking: {
      data: [
        {
          date: "2021-08-27",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 1,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
    },
    memoryCognition: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 6,
          note: "",
        },
      ],
      active: true,
    },
    fatigue: {
      data: [
        {
          date: "2021-02-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 2,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 2,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 4,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
    },
    depression: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 4,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 7,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 7,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 6,
          note: "",
        },
      ],
      active: true,
    },
    pain: {
      data: [
        {
          date: "2021-02-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 6,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 6,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 7,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 6,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 6,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 7,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 7,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 6,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 9,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 6,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 7,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 7,
          note: "",
        },
      ],
      active: true,
    },
  },
  goals: {
    steps: {
      data: [
        {
          date: "2021-02-26",
          value: 4479,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 4070,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 5371,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2010,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 3832,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 2734,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 3616,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 2547,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 2370,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5916,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3582,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1736,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 2973,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 2512,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 1856,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 200,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 2349,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 2261,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 1421,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 228,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 3817,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 4105,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 200,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 200,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2055,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 2243,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 3960,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 2368,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 1317,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 5368,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 804,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 3139,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 3111,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 965,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3076,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3997,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 2297,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 4744,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 3773,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 2772,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3122,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 5611,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3558,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 1368,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 1383,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 1757,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 1591,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 1767,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 1539,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 4640,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 385,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2733,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 2113,
          note: "",
        },
      ],
      active: true,
      target: 2500,
    },
    walkingSpeed: {
      data: [
        {
          date: "2021-02-26",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 0.8,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 0.5,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 0.9,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 0.6,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 0.7,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 0.9,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 0.7,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 0.7,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 0.8,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 0.7,
          note: "",
        },
      ],
      active: true,
      target: 0.9,
    },
    deviceTime: {
      data: [
        {
          date: "2021-02-26",
          value: 9.3,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4.5,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 5.8,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 7.3,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 11.5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 10.9,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 4.9,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 1.7,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 4.2,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 5.3,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 12.6,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3.4,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 5.7,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 0.3,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 3.6,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 5.1,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 0,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 5.4,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 14.5,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 2.3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 8.5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 1.2,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6.5,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 6.9,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 2.3,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 5.1,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 2.4,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 4.7,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 3.7,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5.5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 6.1,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 5.1,
          note: "",
        },
      ],
      active: true,
      target: 6,
    },
    sleepHours: {
      data: [
        {
          date: "2021-02-26",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 9,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 8.7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 9.2,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 6.8,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5.5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 6.9,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 6.4,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 7.8,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 6.7,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 9.4,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 8.6,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 8,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 8.2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 8.8,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 8,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 6.1,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 9,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 11,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 8.4,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 7.9,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 8.9,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 7.5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 6.6,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 8.3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 10.1,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 9.6,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 9,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 7.1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 9.5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 9.1,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 7.4,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 7.6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 7.5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 8.2,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 9,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 9.9,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 8.2,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6.7,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 8.9,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 8.3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 8.3,
          note: "",
        },
      ],
      active: true,
      target: 8.5,
    },
    nightWakings: {
      data: [
        {
          date: "2021-02-26",
          value: 5,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 7,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 1,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 5,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 5,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 1,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 2,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 5,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 7,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 5,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 1,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 0,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 1,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 2,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 8,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 5,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 2,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 5,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 1,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 5,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 6,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 7,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 5,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 6,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 5,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 4,
          note: "",
        },
      ],
      active: true,
      target: 2,
    },
    feelingScore: {
      data: [
        {
          date: "2021-02-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-03-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-03-19",
          value: 2,
          note: "",
        },
        {
          date: "2021-03-26",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-04-16",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-04-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-07",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-14",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-21",
          value: 3,
          note: "",
        },
        {
          date: "2021-05-28",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-04",
          value: 4,
          note: "",
        },
        {
          date: "2021-06-11",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-18",
          value: 3,
          note: "",
        },
        {
          date: "2021-06-25",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-02",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-09",
          value: 3,
          note: "",
        },
        {
          date: "2021-07-16",
          value: 2,
          note: "",
        },
        {
          date: "2021-07-23",
          value: 4,
          note: "",
        },
        {
          date: "2021-07-30",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-06",
          value: 2,
          note: "",
        },
        {
          date: "2021-08-13",
          value: 4,
          note: "",
        },
        {
          date: "2021-08-20",
          value: 3,
          note: "",
        },
        {
          date: "2021-08-27",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-03",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-09-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-09-24",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-01",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-08",
          value: 4,
          note: "",
        },
        {
          date: "2021-10-15",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-22",
          value: 3,
          note: "",
        },
        {
          date: "2021-10-29",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-05",
          value: 3,
          note: "",
        },
        {
          date: "2021-11-12",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-19",
          value: 4,
          note: "",
        },
        {
          date: "2021-11-26",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-03",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-10",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-17",
          value: 3,
          note: "",
        },
        {
          date: "2021-12-24",
          value: 4,
          note: "",
        },
        {
          date: "2021-12-31",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-07",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-14",
          value: 2,
          note: "",
        },
        {
          date: "2022-01-21",
          value: 3,
          note: "",
        },
        {
          date: "2022-01-28",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-04",
          value: 2,
          note: "",
        },
        {
          date: "2022-02-11",
          value: 4,
          note: "",
        },
        {
          date: "2022-02-18",
          value: 3,
          note: "",
        },
        {
          date: "2022-02-25",
          value: 3,
          note: "",
        },
      ],
      active: true,
      target: 5,
    },
  },
  conditions: {
    "multiple sclerosis": {
      diagnosed: "2004-04-12",
      note: "",
    },
  },
  medications: {
    GILENYA: {
      form: "pill",
      note: "Gilenya 0.5 mg tablet, one tablet by mouth once daily",
    },
  },
};

//update the date data?
const updateDateData = theChart => {
  //treatmentPlans;

  //update Symptom dates
  for (const property in theChart.symptoms) {
    let theLength = theChart.symptoms[property].data.length;
    let countDownIndex = theLength - 1;
    for (; countDownIndex > 0; --countDownIndex) {
      theChart.symptoms[property].data[countDownIndex].date = helperGetIsoDate(
        (theLength - countDownIndex) * 7
      ).substring(0, 10);
    }
  }

  //update Symptom dates
  for (const property in theChart.goals) {
    let theLength = theChart.goals[property].data.length;
    let countDownIndex = theLength - 1;
    for (; countDownIndex > 0; --countDownIndex) {
      theChart.goals[property].data[countDownIndex].date = helperGetIsoDate(
        (theLength - countDownIndex) * 7
      ).substring(0, 10);
    }
  }
  return theChart;
};

export const getChart = patientId => {
  if (patientId === "mae1") {
    return updateDateData(mae1);
  }
  if (patientId === "linda1") {
    return updateDateData(linda1);
  }
  if (patientId === "linda2") {
    return updateDateData(linda2);
  }
  if (patientId === "linda3") {
    return updateDateData(linda3);
  }

  return mae1;
};
